import styled from "styled-components";

export const StyledImageOverlay = styled.div`
  ${({ theme }) => `
    .image-overlay_backdrop {
      z-index: 2000000001;
      background-color: rgba(0, 0, 0, 0.9);

      .overlay_container {
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        
        .overlay_image {
          max-width: 80%;
          max-height: 80vh;
          display: block;
          z-index: 200;
          opacity: 100%;
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          left: 50%;
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
        
        .overlay__close-btn {
          position: absolute;
          top: 40px;
          right: 10px;
          z-index: 200;
          background-color: transparent;
          background-repeat: no-repeat;
          border: none;
          cursor: pointer;
          overflow: hidden;
          outline: none;
          color: #fff;
          transition: .2s ease-in-out 0s;
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  `}
`;